import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { Locale } from "../Entities/Locale/Locale";
import { LocaleInterface } from "../Entities/Locale/LocaleInterface";

class LocaleFactory extends Factory implements FactoryInterface {

  public create(data: any): LocaleInterface {
    return new Locale({
      iso: data.iso
    });
  }

  public reinitialize(data: any): LocaleInterface {
    return new Locale({
      ...data
    });
  }
}

export default new LocaleFactory();
